import React from 'react';

import { inMobileOrTabletBrowser } from '@reverbdotcom/commons/src/user_context_helpers';
import { conditionSlugForUuid } from '@reverbdotcom/commons/src/condition_helpers';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/src/elog/mparticle';
import experiments from '@reverbdotcom/commons/src/experiments';

import PriceHistoryGraphContainer from '../shared/price_history_graph_container';
import CSPTransactionTableContainer from '../shared/csp_transaction_table_container';
import { 
  V2_MOBILE_TRANSACTION_TABLE_PAGE_SIZE, 
  V2_TRANSACTION_TABLE_PAGE_SIZE, 
} from './v2_csp_price_guide_module_table_container';

export default function V2CSPPriceGuideModuleGraphAndTableContainer({
  canonicalProductIds,
  conditionUuids,
  csp,
}) {
  const user = useUser();
  const conditionSlugs = conditionUuids.map(conditionUuid => conditionSlugForUuid(conditionUuid));

  const hasModelSelected = canonicalProductIds.length === 1;
  const selectedModelId = hasModelSelected ? canonicalProductIds[0] : null;

  const hasConditionSelected = conditionSlugs.length === 1;
  const selectedConditionSlug = hasConditionSelected ? conditionSlugs[0] : null;

  useViewTracking({
    componentName: 'V2CSPPriceGuideModuleGraphAndTableContainer',
    eventName: MParticleEventName.ComponentView,
    cspId: csp.id,
    cspSlug: csp.slug,
    cpId: selectedModelId,
    conditionSlug: selectedConditionSlug,
    experiments: formatExperimentsForEventAttributes(user, [
      experiments.PRICE_GUIDE_TOOL_CSP_MODULE_V2,
    ]),
  }, true);

  return (
    <div className="v2-csp-price-guide-module-graph-and-table-container">
      <div className="v2-csp-price-guide-module-graph-and-table-container__price-graph">
        <PriceHistoryGraphContainer
          csp={csp}
          canonicalProductIds={canonicalProductIds}
          conditionUuids={conditionUuids}
        />
      </div>
     
      <div className="v2-csp-price-guide-module-graph-and-table-container__transaction-table">
        <CSPTransactionTableContainer
          csp={csp}
          canonicalProductIds={canonicalProductIds}
          conditionSlugs={conditionSlugs}
          pageSize={inMobileOrTabletBrowser(user) ? V2_MOBILE_TRANSACTION_TABLE_PAGE_SIZE : V2_TRANSACTION_TABLE_PAGE_SIZE}
        />
      </div>
    </div>
  );
}
